import { Injectable } from '@angular/core';
import { Service } from 'src/app/core/jsonapi/service';
import { DataProtectionRequest } from '../_types/data-protection-request';
import { firstValueFrom, Observable } from 'rxjs';
import { TemplatesService } from '../../templates/_services/templates.service';
import { HttpClient } from '@angular/common/http';
import { LoaderService } from 'src/app/core/loader/loader.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';

export interface CreateDataProtectionRequestPayload {
    reason: string;
    from: Date;
    to: Date;
    companyId: string;
    contractId: string;
    clientName?: string;
    clientPhone?: string;
    clientEmail?: string;
    config: unknown;
    caseIds: string[];
}

@Injectable({
    providedIn: 'root'
})
export class DataProtectionRequestsService extends Service<DataProtectionRequest> {
    public override type = 'dataProtectionRequests';
    public override url = 'common/dataProtectionRequests';

    constructor(
        httpService: HttpClient,
        loaderService: LoaderService,
        private templateService:TemplatesService
    ){
        super(httpService, loaderService);
    }

    public createRequest(payload: CreateDataProtectionRequestPayload): Observable<{ id: string; lines: number; }> {
        return this.http.post<{ id: string; lines: number; }>(this.getAPIUrl() + '/createRequest', payload);
    }

    public exportPdf(id: string): Promise<Blob> {
        return new Promise(async (resolve, reject) => {
            let filters = {
                documentType: new Filter(FilterOperation.equals, 'documentType', '', 'protection_data_request')
            };
            let params:IParamsCollection = {
                filter: FilterBuilder.fromObject(filters).build()
            };
            let templates = await firstValueFrom(this.templateService.all(params));
            if(templates.data.length === 0){
                reject('No se ha encontrado la plantilla para exportar la solicitud de protección de datos.');
                return;
            }
            let templateId = templates.data[0].id;
            this.http.get(this.getAPIUrl() + '/' + id + '/export/pdf?templateId=' + templateId, { responseType: 'blob' }).subscribe({
                next: (response: Blob) => resolve(response),
                error: (error: any) => reject(error)
            });
        });
    }
}